var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendingSmallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.426,
    height: 82.26,
    viewBox: "0 0 74.426 82.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_1",
    "data-name": 1,
    transform: "translate(-28.286 -24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1979",
    "data-name": "Path 1979",
    d: "M37.258,93.078a2.427,2.427,0,0,1-1.715-4.142L50.536,73.942a2.426,2.426,0,0,1,3.43,3.43L38.973,92.366A2.427,2.427,0,0,1,37.258,93.078Z",
    fill: "#c7c8c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1980",
    "data-name": "Path 1980",
    d: "M39.091,106.26a2.428,2.428,0,0,1-1.78-4.078l11.9-12.793a2.427,2.427,0,0,1,3.56,3.3l-11.9,12.793A2.413,2.413,0,0,1,39.091,106.26Z",
    fill: "#c7c8c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1981",
    "data-name": "Path 1981",
    d: "M29.534,55.346l19.19,7.626a9.176,9.176,0,0,0,8.521-.906L74.785,50.352a1.144,1.144,0,0,1,1.586,1.586l-11.7,17.69a9.2,9.2,0,0,0-.874,8.489l7.583,19.071a1.976,1.976,0,0,0,3.678-.011l27.518-70.47A1.984,1.984,0,0,0,100,24.14L29.545,51.657a1.976,1.976,0,0,0-.011,3.678Z",
    fill: "#c7c8c7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendingSmallIcon);
export default __webpack_public_path__ + "static/media/sending-small-icon.5278d011.svg";
export { ForwardRef as ReactComponent };